const translations = {
  "en": {
    "Continue with Apple": "Continue with Apple",
    "Continue with Google": "Continue with Google",
    "Continue with Twitter": "Continue with X",
    "I accept the": "I accept the",
    "Login / Sign up": "Login / Sign Up to Ed",
    "or": "or",
    "Please agree to the Privacy Policy first": "Please agree to the Privacy Policy first",
    "Privacy Policy": "Privacy Policy",
    "Sign up & get 3 latest Alpha Signals": "Sign up & get 3 latest Alpha Signals",
    "Terms of Use": "Terms of Use",
    "Welcome to Edgen": "Welcome to Ed"
  },
  "zh-tw": {
    "Continue with Apple": "透過 Apple 繼續",
    "Continue with Google": "透過 Google 繼續",
    "Continue with Twitter": "透過 X 繼續",
    "I accept the": "我同意",
    "Login / Sign up": "登入 / 註冊 Ed",
    "or": "或",
    "Please agree to the Privacy Policy first": "請先同意隱私權政策",
    "Privacy Policy": "隱私權政策",
    "Sign up & get 3 latest Alpha Signals": "註冊並獲取 3 個最新的 Alpha 訊號",
    "Terms of Use": "使用條款",
    "Welcome to Edgen": "歡迎來到 Ed"
  }
};

export default translations;
